
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 680 200"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Capa 2"}},[_c('g',{attrs:{"fill":"#8c9091","data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M400 80H280v40h120v40H280v40h120v-40h40v-40h-40V80zM680 80h-40v40-40H520V0h-40v80h40v40h-40v80h40v-80h120v80h40V80zM640 0h40v40h-40zM0 160h40v40H0zM160 40h-40v40h40v120h40V0h-40v40zM80 40H40V0H0v160h40V80h40V40zM80 80h40v40H80zM320 40h80V0H280v40h-40v40h40V40h40z"}})])])])
          )
        }
      }
    